const MS_DEFAULT_TEMPLATE_SPACE_ID = 103937;
const GLOBAL_VARIABLE_DATASOURCE_ID = 105993;
const MENTOR_PROFILE_DATASOURCE = 100366;

module.exports = {
	MENTOR_PROFILE_DATASOURCE,
	GLOBAL_VARIABLE_DATASOURCE_ID,
	MS_DEFAULT_TEMPLATE_SPACE_ID,
};
